export function StepCard({ title, desc, status, icon, actionLabel }) {
  return (
    <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
      <div className="border rounded-lg p-4 w-full mt-6">
      <h2 className="text-md font-semibold">Verify Account</h2>
      <p className="text-sm text-gray-500 mt-1">Complete identity verification to access all Tillionx services</p>

      {actionLabel && (
        <button className="mt-4 bg-yellow-400 px-4 py-2 rounded font-medium">
          {actionLabel}
        </button>
      )}

      {status && (
        <div className="mt-2 text-sm text-gray-500 flex items-center gap-2">
          <span className="text-gray-400">{icon}</span>
          {status}
        </div>
      )}
    </div>
    </div>
  );
}